import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy } from 'react';

const LazyUserSelector = lazy(() =>
  import('./userSelector')
    .then((module) => ({ default: module.UserSelector }))
    .catch(() => {
      document.location.reload();
      return { default: () => <></> };
    })
);

export const UserSelector = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyUserSelector />
  </Suspense>
);
